import React, { useEffect, useRef, useState } from "react";
import {
  Toolbar,
  ToolbarContent,
  ToolbarItem,
  Button,
  Flex,
  InputGroup,
  SearchInput,
  Badge,
  Dropdown, DropdownItem, DropdownList,
  MenuToggle
} from "@patternfly/react-core";
import { TimesIcon, TableIcon, ThLargeIcon } from "@patternfly/react-icons";
import { getMonths } from "shared/utils/monthsUtils";

export const SheetsToolbar = ({
    context,
    search,
    setSearch,
    yearFilter,
    setYearFilter,
    sessionFilter,
    setSessionFilter,
    groupFilter,
    setGroupFilter,
    statusFilter,
    setStatusFilter,
    availableSessions = [],
    availableGroups = [],
    availableYears = [],
    viewMode,
    setViewMode,
    resultCount = 0   // 👈 nowy props ilość arkkuszy po filtracji
  }) => {

    const [openDropdown, setOpenDropdown] = useState(null);
    const toggleDropdown = (name) => {
      setOpenDropdown(prev => prev === name ? null : name);
    };

  const yearLabelText = yearFilter || "Wszystkie lata";
  
  const sessionNames = {
    "1": "Styczeń",
    "2": "Luty",
    "3": "Marzec",
    "4": "Kwiecień",
    "5": "Maj",
    "6": "Czerwiec",
    "7": "Lipiec",
    "8": "Sierpień",
    "9": "Wrzesień",
    "10": "Październik",
    "11": "Listopad",
    "12": "Grudzień",
  };
  const sessionLabel = sessionFilter
      ? `${sessionNames[sessionFilter]}`
      : `Wszystkie sesje`;

  const groupLabel = groupFilter
    ? `${groupFilter}`
    : `Wszystkie grupy`;

  const statusLabels = {
    all: "Wszystkie arkusze",
    completed: "Zrealizowane",
    not_completed: "Nie zrealizowane"
  };  

  const statusLabel = statusFilter && statusLabels[statusFilter]
    ? `${statusLabels[statusFilter]}`
    : `Wszystkie arkusze`;

  const searchRef = useRef(null);
  
  // ESC clear search
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        setSearch("");
        searchRef.current?.focus();
      }
    };

    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [setSearch]);

  return (
    <>
    <Toolbar isSticky="true">
      <ToolbarContent>
        {/* SEARCH */}
        <ToolbarItem>
          <InputGroup>
            <SearchInput
              style={{ width: '270px' }} // możesz podać px lub %
              id="sheet-search-input"
              aria-label="Search sheets"
              value={search}
              onChange={(_, val) => setSearch(val)}
              placeholder="Szukaj [ Rodzaj, Id, Arkusz ]"
              ref={searchRef}
            />
            {search && (
              <Button
                variant="control"
                onClick={() => setSearch("")}
              >
                <TimesIcon />
              </Button>
            )}
          </InputGroup>
        </ToolbarItem>
        {/* YEAR FILTER */}
        <ToolbarItem>
          <Dropdown
            isOpen={openDropdown === "year"}
            onOpenChange={(open) => {
              if (!open) setOpenDropdown(null);
            }}
            toggle={toggleRef => (
              <MenuToggle
                ref={toggleRef}
                onClick={() => toggleDropdown("year")}
                isExpanded={openDropdown === "year"}
              >
                <Flex alignItems={{ default: "alignItemsCenter" }} gap="sm">
                  <span>{yearLabelText}</span>
                  <Badge isRead>{resultCount}</Badge>
                </Flex>
              </MenuToggle>
            )}
          >
            <DropdownList>
              <DropdownItem
                key="all"
                
                onClick={() => {
                  setYearFilter("");
                  setOpenDropdown(null);
                }}
                isSelected={yearFilter === ""}
              >
                Wszystkie lata
              </DropdownItem>

              {availableYears.map(year => (
                <DropdownItem
                  key={year}
                  onClick={() => {
                    setYearFilter(year);
                    setOpenDropdown(null);
                  }}
                  isSelected={yearFilter === year}
                >
                  {year}
                </DropdownItem>
              ))}
            </DropdownList>
          </Dropdown>
        </ToolbarItem>
        {/* SESSION FILTER */}
        <ToolbarItem>
          <Dropdown
            isOpen={openDropdown === "session"}
            onOpenChange={(open) => {
              if (!open) setOpenDropdown(null);
            }}
            toggle={toggleRef => (
              <MenuToggle
                ref={toggleRef}
                onClick={() => toggleDropdown("session")}
                isExpanded={openDropdown === "session"}
              >
                {sessionLabel}
              </MenuToggle>
            )}
          >
            <DropdownList>
              <DropdownItem
                key="all"
                onClick={() => {
                    setSessionFilter("");
                    setOpenDropdown(null);
                }}
                isSelected={sessionFilter === ""}
              >
                Wszystkie sesje
              </DropdownItem>
              {availableSessions.map(s => (
                <DropdownItem
                  key={s}
                  onClick={() => {
                      setSessionFilter(s);
                      setOpenDropdown(null);
                  }}
                  isSelected={sessionFilter === s}
                >
                  {getMonths(s)}
                </DropdownItem>
              ))}
              {/* <DropdownItem
                key="1"
                onClick={() => {
                    setSessionFilter("1");
                    setOpenDropdown(null);
                }}
                isSelected={sessionFilter === "1"}
              >
                Styczeń
              </DropdownItem>

              <DropdownItem
                key="6"
                onClick={() => {
                    setSessionFilter("6");
                    setOpenDropdown(null);
                }}
                isSelected={sessionFilter === "6"}
              >
                Czerwiec
              </DropdownItem>
              <DropdownItem
                key="8"
                onClick={() => {
                    setSessionFilter("8");
                    setOpenDropdown(null);
                }}
                isSelected={sessionFilter === "8"}
              >
                Sierpień
              </DropdownItem> */}
            </DropdownList>
          </Dropdown>
        </ToolbarItem>
        {/* GROUP FILTER */}
        {context.state.isAuthUser && (
          <>
        <ToolbarItem>
          <Dropdown
            isOpen={openDropdown === "group"}
            onOpenChange={(open) => {
              if (!open) setOpenDropdown(null);
            }}
            toggle={toggleRef => (
              <MenuToggle
                ref={toggleRef}
                onClick={() => toggleDropdown("group")}
                isExpanded={openDropdown === "group"}
              >
                {groupLabel}
              </MenuToggle>
            )}
          >
            <DropdownList>
              <DropdownItem
                key="all"
                onClick={() => {
                    setGroupFilter("");
                    setOpenDropdown(null);
                }}
                isSelected={!groupFilter}
              >
                Wszystkie grupy
              </DropdownItem>

              {availableGroups.map(g => (
                <DropdownItem
                  key={g}
                  onClick={() => {
                      setGroupFilter(g);
                      setOpenDropdown(null);
                  }}
                  isSelected={groupFilter === g}
                >
                  {g}
                </DropdownItem>
              ))}
            </DropdownList>
          </Dropdown>
        </ToolbarItem>
        {/* STATUS FILTER */}
        <ToolbarItem>
          <Dropdown
            isOpen={openDropdown === "status"}
            onOpenChange={(open) => {
              if (!open) setOpenDropdown(null);
            }}
            toggle={toggleRef => (
              <MenuToggle
                ref={toggleRef}
                onClick={() => {
                  toggleDropdown("status");
                }}
                isExpanded={openDropdown === "status"}
                isDisabled={!groupFilter}
              >
                {statusLabel}
              </MenuToggle>
            )}
          >
            <DropdownList>

              <DropdownItem
                onClick={() => {
                  setStatusFilter("all");
                  setOpenDropdown(null);
                }}
                isSelected={statusFilter === "all"}
              >
                Wszystkie arkusze
              </DropdownItem>

              <DropdownItem
                onClick={() => {
                  setStatusFilter("completed");
                  setOpenDropdown(null);
                }}
                isSelected={statusFilter === "completed"}
              >
                Zrealizowane
              </DropdownItem>

              <DropdownItem
                onClick={() => {
                  setStatusFilter("not_completed");
                  setOpenDropdown(null);
                }}
                isSelected={statusFilter === "not_completed"}
              >
                Nie zrealizowane
              </DropdownItem>

            </DropdownList>
          </Dropdown>
        </ToolbarItem>
        </>
        )}
        <ToolbarItem>
          <Button
            variant="control"
            onClick={() =>
              setViewMode(prev => (prev === "table" ? "cards" : "table"))
            }
          >
            {viewMode === "table" ? <ThLargeIcon /> : <TableIcon />}
          </Button>
        </ToolbarItem>
        <ToolbarItem>
          <Button
            variant="link"
            onClick={() => {
              setSearch("");
              setYearFilter("");
              setSessionFilter("");
              setGroupFilter("");
              setStatusFilter("all");
            }}
          >
            Czyść filtry
          </Button>
        </ToolbarItem>
      </ToolbarContent>
    </Toolbar>
    <br />
    </>
  );
};